/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UnitAlertHistoryResponseServiceResult } from '../models/UnitAlertHistoryResponseServiceResult';
import type { UnitLocationHistoryResponseServiceResult } from '../models/UnitLocationHistoryResponseServiceResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SleeperUnitHistoryApiClient {

    /**
     * Used to get Location history of a sleeper unit.Expected Date format is yyyy-mm-dd e.g. 2022-12-23.
     * @param unitId
     * @param fromDate
     * @param toDate
     * @returns UnitLocationHistoryResponseServiceResult Success
     * @throws ApiError
     */
    public static getApiV1UnitLocationHistory(
        unitId: number,
        fromDate: string = '2001-01-01',
        toDate: string = '2099-01-01',
    ): CancelablePromise<UnitLocationHistoryResponseServiceResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Unit/LocationHistory/{unitId}',
            path: {
                'unitId': unitId,
            },
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
        });
    }

    /**
     * Used to get Alert history of a sleeper unit.Expected Date format is yyyy-mm-dd e.g. 2022-12-23.
     * @param unitId
     * @param fromDate
     * @param toDate
     * @returns UnitAlertHistoryResponseServiceResult Success
     * @throws ApiError
     */
    public static getApiV1UnitAlertHistory(
        unitId: number,
        fromDate: string = '2001-01-01',
        toDate: string = '2099-01-01',
    ): CancelablePromise<UnitAlertHistoryResponseServiceResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Unit/AlertHistory/{unitId}',
            path: {
                'unitId': unitId,
            },
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
        });
    }

}
